<template>
  <v-layout row wrap>
    <v-flex v-bind="headerPadding" md12 v-if="!!$slots['header']">
      <slot name="header"></slot>
    </v-flex>
    <v-flex md8 v-if="!!$slots['first-col']">
      <v-container v-bind="padding" grid-list-lg>
        <v-layout row wrap>
          <slot name="first-col"></slot>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex md4 v-if="!!$slots['second-col']">
      <v-container v-bind="padding" grid-list-lg>
        <v-layout row wrap>
          <slot name="second-col"></slot>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex md12 v-if="!!$slots['footer-row']">
      <v-container v-bind="padding" grid-list-lg>
        <v-layout row wrap>
          <slot name="footer-row"></slot>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      years: {
        // 2021: '2021',
        2020: '2020',
        2019: '2019',
        2018: '2018',
        2017: '2017',
        2016: '2016',
        2015: '2015',
      },
      text: 'year',
      year: '2020',
    };
  },
  computed: {
    padding() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return { 'pa-0': true };
        case 'sm':
          return { 'pa-0': true };
        case 'md':
          return { 'px-2': true };
        case 'lg':
          return { 'px-2': true };
        case 'xl':
          return { 'px-2': true };
        default:
          return { 'px-2': true };
      }
    },
    headerPadding() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return { 'pa-0': true };
        case 'sm':
          return { 'pa-0': true };
        case 'md':
          return { 'px-3': true };
        case 'lg':
          return { 'px-3': true };
        case 'xl':
          return { 'px-3': true };
        default:
          return { 'px-3': true };
      }
    },
  },
};
</script>
